// core imports
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';

// business imports
import { SafeUrlPipe } from './safe-url.pipe';
import { TpvIntegrationComponent } from './tpv-integration.component';

@NgModule({
  declarations: [
    SafeUrlPipe,
    TpvIntegrationComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    TranslateModule
  ],
  exports: [
    TpvIntegrationComponent
  ]
})
export class TpvIntegrationModule { }
